import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Container, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { Section } from "../../shared";
import { Formik } from "formik";
import axios from "axios";
import Loading, { SmallLoading } from "../../shared/Loading";
import ValidationSchema from "./FormValidation";
import initialFormValues from "./InitialFormValues";

import RequestorInfo from "./RequestorInfo";
import LocationSection from "./LocationSection";
import MailingSection from "./MailingSection";
import ContactSection from "./ContactSection";
import OwnerSection from "./OwnerSection";
import { Debug } from "../../shared/utilities/Debug";

export default function TempidApplication() {
  const [initialValues, setInitialValues] = useState(initialFormValues);
  const [readOnly, setReadOnly] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const toggleModal = () => setShowModal(!showModal);
  const [modalTitle, setModalTitle] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const [showCancelModal, setShowCancelModal] = useState(false);
  const toggleCancelModal = () => setShowCancelModal(!showCancelModal);

  const onSubmit = async (formData, formikBag) => {
    let naics = formData.facilityNaics.map((obj) => {
      let value = obj.value;
      return value;
    });
    let types = formData.facilityTypes.map((obj) => {
      let value = obj.value;
      return value;
    });

    var queryObject = {
      FacilityLocation: {
        EPA_ID: formData.facilityEPAID,
        FAC_NAME: formData.facilityName,
        FAC_STR1: formData.locationStreet1,
        FAC_STR2: formData.locationStreet2,
        FAC_CITY: formData.locationCity,
        FAC_CNTY: formData.locationCounty.value,
        FAC_ST: formData.locationState.value,
        FAC_ZIP: formData.locationZip,
        FAC_ACT_IND: formData.facilityActive.value,
        INACT_DATE: formData.facilityInactiveDate,
        FAC_AKA: formData.facilityAlias,
      },
      FacilityDetail: {
        EPA_ID: formData.facilityEPAID,
        Fed_Employer_ID: formData.facilityFEIN,
        BOE_Number: formData.facilityBOENumber,
        MAIL_NAME: formData.mailingAttention,
        FAC_MAIL_STR1: formData.mailingStreet1,
        FAC_MAIL_STR2: formData.mailingStreet2,
        FAC_MAIL_CITY: formData.mailingCity,
        FAC_MAIL_ST: formData.mailingState.value,
        FAC_MAIL_ZIP: formData.mailingZip,
        REGION_CODE: formData.locationRegion.value,
        OWNER_NAME: formData.ownerName,
        OWNER_STR1: formData.ownerStreet1,
        OWNER_STR2: formData.ownerStreet2,
        OWNER_CITY: formData.ownerCity,
        OWNER_ST: formData.ownerState.value,
        OWNER_ZIP: formData.ownerZip,
        OWNER_PHONE: formData.ownerPhone.replace("-", ""),
        Owner_Fax: formData.ownerFax.replace("-", ""),
        CONTACT_NAME: formData.contactName,
        CONTACT_STR1: formData.contactStreet1,
        CONTACT_STR2: formData.contactStreet2,
        CONTACT_CITY: formData.contactCity,
        CONTACT_ST: formData.contactState.value,
        CONTACT_ZIP: formData.contactZip,
        CONTACT_PHONE: formData.contactPhone.replace("-", ""),
        CONTACT_FAX: formData.contactFax.replace("-", ""),
        CONTACT_EMAIL: formData.contactEmail,
        CALL_BUS_NAME: formData.callerBusiness,
        CALL_NAME: formData.callerName,
        CALL_STR1: formData.callerStreet1,
        CALL_STR2: formData.callerStreet2,
        CALL_CITY: formData.callerCity,
        CALL_ST: formData.callerState.value,
        CALL_ZIP: formData.callerZip,
        CALL_PHONE: formData.callerPhone.replace("-", ""),
        CALL_FAX: formData.callerFax.replace("-", ""),
        CALL_EMAIL: formData.callerEmail,
        USEPA_IND: formData.facilityUSEPA.value,
        EPA_TYPE_IND: formData.facilityEPAIDType.value,
        PREF_MEDIA_IND: formData.contactMedia.value,
        OWNER_EXT: formData.ownerPhoneExt,
        CONTACT_EXT: formData.contactPhoneExt,
        CALL_EXT: formData.callerPhoneExt,
        CMNT: formData.facilityComments,
        //   CONTACT_COUNTRY: formData.CONTACT_COUNTRY,
        //   OWNER_COUNTRY: formData.OWNER_COUNTRY,
        //   CALL_COUNTRY: formData.CALL_COUNTRY,
        //   FAC_MAIL_COUNTRY: formData.FAC_MAIL_COUNTRY,
      },
      FacilityNaics: naics,
      FacilityTypes: types,
    };
    //setModalSubmitting();
    toggleModal();
    //createFacility(formData, queryObject);
  };

  const createFacility = async (formData, queryObject) => {
    await axios
      .post(`api/v1/hwts/admin/facilities/addfacility`, queryObject)
      .then((res) => {
        setModalTitle("Success!");
        setModalMessage(
          `The facility ${formData.facilityEPAID} - ${formData.facilityName} was created successfully.`
        );
        setReadOnly(true);
        setIsSubmitting(false);
      })
      .catch((err) => {
        setModalTitle("Failed!");
        setModalMessage(
          <div>
            <div>{`Creating the facility ${formData.facilityEPAID} - ${formData.facilityName} was unsuccessful.`}</div>
          </div>
        );
        setIsSubmitting(false);
        //toggleModal();
      });
  };

  const onKeyDown = async (keyEvent) => {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      keyEvent.preventDefault();
    }
  };

  return (
    <div className="">
      <Section title="Temporary CA ID Number Application" type={"standout"} />
      <div className="container mt-2" style={{ fontSize: "0.9em" }}>
        <Modal show={showModal} onHide={toggleModal} className="">
          <Modal.Header closeButton>Submit ID Number Application</Modal.Header>
          <Modal.Body>
            <div className="full-width">
              <div>
                Are you sure you want to submit this Temporary ID Number
                Application?
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Row className="full-width mx-0">
              <Col xs="6" className="text-center">
                <Button
                  variant="success"
                  size="lg"
                  style={{ width: "200px" }}
                  //onClick={() => deleteFacility(epaId)}
                >
                  Submit
                </Button>
              </Col>
              <Col xs="6" className="text-center">
                <Button
                  variant="secondary"
                  size="lg"
                  style={{ width: "200px" }}
                  onClick={toggleModal}
                >
                  No
                </Button>
              </Col>
            </Row>
          </Modal.Footer>
        </Modal>
        <Modal show={showCancelModal} onHide={toggleCancelModal} className="">
          <Modal.Header closeButton>Cancel</Modal.Header>
          <Modal.Body>
            <div className="full-width">
              <div>Are you sure you want to cancel?</div>
              <div>All information will be lost.</div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Row className="full-width mx-0">
              <Col xs="6" className="text-center">
                <Link to="/profile">
                  <Button variant="danger" size="lg" style={{ width: "200px" }}>
                    Confirm
                  </Button>
                </Link>
              </Col>
              <Col xs="6" className="text-center">
                <Button
                  variant="secondary"
                  size="lg"
                  style={{ width: "200px" }}
                  onClick={toggleCancelModal}
                >
                  No
                </Button>
              </Col>
            </Row>
          </Modal.Footer>
        </Modal>
        <Container>
          <Formik
            validateOnChange={false}
            validateOnBlur={false}
            validationSchema={ValidationSchema}
            onSubmit={(values) => onSubmit(values)}
            initialValues={initialValues}
          >
            {({
              isSubmitting,
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              touched,
              isValid,
              errors,
              setErrors,
              resetForm,
              setFieldValue,
            }) => (
              <Form onSubmit={handleSubmit} onKeyDown={onKeyDown}>
                <RequestorInfo
                  onChange={handleChange}
                  onBlur={handleBlur}
                  values={values}
                  onSubmit={handleSubmit}
                  errors={errors}
                  isSubmitting={isSubmitting}
                  setFieldValue={setFieldValue}
                  touched={touched}
                  readOnly={readOnly}
                />
                <Row>
                  <Col xs="6">
                    <LocationSection
                      onChange={handleChange}
                      onBlur={handleBlur}
                      values={values}
                      onSubmit={handleSubmit}
                      errors={errors}
                      isSubmitting={isSubmitting}
                      setFieldValue={setFieldValue}
                      touched={touched}
                      readOnly={readOnly}
                    />
                  </Col>
                  <Col xs="6">
                    <MailingSection
                      onChange={handleChange}
                      onBlur={handleBlur}
                      values={values}
                      onSubmit={handleSubmit}
                      errors={errors}
                      isSubmitting={isSubmitting}
                      setFieldValue={setFieldValue}
                      touched={touched}
                      readOnly={readOnly}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs="6">
                    <ContactSection
                      onChange={handleChange}
                      onBlur={handleBlur}
                      values={values}
                      onSubmit={handleSubmit}
                      errors={errors}
                      isSubmitting={isSubmitting}
                      setFieldValue={setFieldValue}
                      touched={touched}
                      readOnly={readOnly}
                    />
                  </Col>
                  <Col xs="6">
                    <OwnerSection
                      onChange={handleChange}
                      onBlur={handleBlur}
                      values={values}
                      onSubmit={handleSubmit}
                      errors={errors}
                      isSubmitting={isSubmitting}
                      setFieldValue={setFieldValue}
                      touched={touched}
                      readOnly={readOnly}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs="6" className="text-center">
                    <Button
                      variant="danger"
                      size="lg"
                      //type="submit"
                      onClick={(e) => toggleCancelModal(e)}
                      disabled={isSubmitting || readOnly}
                      style={{ width: "200px" }}
                    >
                      Cancel
                    </Button>
                  </Col>
                  <Col xs="6" className="text-center">
                    <Button
                      variant="success"
                      size="lg"
                      //type="submit"
                      onClick={(e) => toggleModal(e)}
                      disabled={isSubmitting || readOnly}
                      style={{ width: "200px" }}
                    >
                      Confirm
                    </Button>
                  </Col>
                </Row>
                <Debug />
              </Form>
            )}
          </Formik>
        </Container>
      </div>
    </div>
  );
}
